import React from "react";
import { CaretRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { FadersHorizontal } from "@phosphor-icons/react";
const ProductsLanding = ({ data, catName, isBrandFilter, onHandleFiler }) => {
  console.log(data?.brand_logo);
  return (
    <div className="lg:flex-[3] mt-16 lg:mt-0 ">
      <button
        onClick={onHandleFiler}
        className="text-white flex xl:hidden items-end justify-end w-max ml-auto  mb-4"
      >
        <FadersHorizontal size={28} />
      </button>
      {data && data?.brand_logo && (
        <div className="flex flex-col items-start lg:flex-row lg:items-center gap-x-4 mb-12 ">
          <img
            className="w-[9rem] lg:w-[12rem] object-contain"
            src={data?.brand_logo}
            alt=""
          />

          <div
            className="text-white text-sm md:text-base"
            dangerouslySetInnerHTML={{ __html: data?.short_description }}
          />
        </div>
      )}
      {data?.data?.map(
        ({ product_series, products, segment_name }, seriesIndex) => (
          <div key={seriesIndex} className="mb-24">
            <h3 className="text-3xl lg:text-4xl bebas text-white flex flex-wrap items-center gap-x-2">
              {isBrandFilter ? segment_name : catName} {/* Adjust title */}
              <span>
                <CaretRight weight="bold" size={20} />
              </span>
              {product_series}
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-2 xxl:gap-6 mt-10">
              {products?.map(
                ({ product_image, product_name, slug }, productIndex) => (
                  <Link
                    to={`/detailed-product/${slug}`}
                    className="group"
                    key={productIndex}
                  >
                    <div className="h-[200px]  w-full overflow-hidden">
                      <img
                        className="h-full w-full transition ease-in duration-300 group-hover:scale-[1.1]  object-contain"
                        src={product_image}
                        alt={product_name}
                      />
                    </div>
                    <p className="text-white text-lg mt-2">{product_name}</p>
                  </Link>
                )
              )}
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default ProductsLanding;
